import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/contact/send_email_big.svg';
const SendEmailBigSvg = () => React.createElement(IconSvg, null);
export default SendEmailBigSvg;
